import { c as _c } from "react/compiler-runtime";
import { cn } from '@achra/ui/lib/utils';
import { Skeleton } from '@achra/ui/skeleton';
import { buildWidths, MAX_ROWS } from '@/modules/builders/lib/skeletons-helpers';
import { BuildersProfileSkeleton } from '../builders-profile-skeleton/builders-profile-skeleton';
import { BuildersSkillsSkeleton } from '../builders-skills-skeleton/builders-skills-skeleton';
function BuildersTableHeaderSkeleton() {
  const $ = _c(3);
  let t0;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t0 = <div className="flex items-center gap-2"><Skeleton className="h-6 w-16" /><Skeleton className="h-4 w-4" /></div>;
    $[0] = t0;
  } else {
    t0 = $[0];
  }
  let t1;
  if ($[1] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = <div className="flex items-center gap-2"><Skeleton className="h-6 w-8.5" /><Skeleton className="h-4 w-4" /></div>;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  let t2;
  if ($[2] === Symbol.for("react.memo_cache_sentinel")) {
    t2 = <div className="border-border bg-background grid grid-cols-[36%_26%_19%_1fr] gap-2 rounded-xl border px-6 py-4 shadow-sm">{t0}{t1}<div className="flex items-center gap-2"><Skeleton className="h-6 w-26.5" /><Skeleton className="h-4 w-4" /></div></div>;
    $[2] = t2;
  } else {
    t2 = $[2];
  }
  return t2;
}
interface BuildersTableBodyRowSkeletonProps {
  builderNameWidth: number;
  builderSkillsWidth: number;
}
function BuildersTableBodyRowSkeleton(t0) {
  const $ = _c(9);
  const {
    builderNameWidth,
    builderSkillsWidth
  } = t0;
  let t1;
  if ($[0] !== builderNameWidth) {
    t1 = <BuildersProfileSkeleton builderNameWidth={builderNameWidth} />;
    $[0] = builderNameWidth;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  let t2;
  if ($[2] !== builderSkillsWidth) {
    t2 = <BuildersSkillsSkeleton builderSkillsWidth={builderSkillsWidth} />;
    $[2] = builderSkillsWidth;
    $[3] = t2;
  } else {
    t2 = $[3];
  }
  let t3;
  if ($[4] === Symbol.for("react.memo_cache_sentinel")) {
    t3 = <div className="flex flex-col gap-1"><Skeleton className="h-4.5 w-20" /><Skeleton className="h-5.5 w-21" /></div>;
    $[4] = t3;
  } else {
    t3 = $[4];
  }
  let t4;
  if ($[5] === Symbol.for("react.memo_cache_sentinel")) {
    t4 = <div className="flex items-center justify-end gap-4"><Skeleton className="h-9 w-23" /><Skeleton className="h-9 w-9" /></div>;
    $[5] = t4;
  } else {
    t4 = $[5];
  }
  let t5;
  if ($[6] !== t1 || $[7] !== t2) {
    t5 = <div className="border-border bg-background grid grid-cols-[36%_26%_19%_1fr] gap-2 rounded-xl border px-6 py-4 shadow-sm">{t1}{t2}{t3}{t4}</div>;
    $[6] = t1;
    $[7] = t2;
    $[8] = t5;
  } else {
    t5 = $[8];
  }
  return t5;
}
function BuildersTableBodySkeleton() {
  const $ = _c(3);
  let t0;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t0 = buildWidths({
      min: 15,
      max: 48,
      seed: 12345
    });
    $[0] = t0;
  } else {
    t0 = $[0];
  }
  const builderProfileWidths = t0;
  let t1;
  if ($[1] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = buildWidths({
      min: 28,
      max: 43,
      seed: 67890
    });
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  const builderSkillsWidths = t1;
  let t2;
  if ($[2] === Symbol.for("react.memo_cache_sentinel")) {
    t2 = <div className="flex flex-col gap-2">{Array.from({
        length: MAX_ROWS
      }, (_, index) => {
        const builderNameWidth = builderProfileWidths[index] ?? 15;
        const builderSkillsWidth = builderSkillsWidths[index] ?? 28;
        return <BuildersTableBodyRowSkeleton key={`builder-skeleton-${index}`} builderNameWidth={builderNameWidth} builderSkillsWidth={builderSkillsWidth} />;
      })}</div>;
    $[2] = t2;
  } else {
    t2 = $[2];
  }
  return t2;
}
interface BuildersTableSkeletonProps {
  className?: string;
}
function BuildersTableSkeleton(t0) {
  const $ = _c(6);
  const {
    className
  } = t0;
  let t1;
  if ($[0] !== className) {
    t1 = cn("flex flex-col gap-2", className);
    $[0] = className;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  let t2;
  let t3;
  if ($[2] === Symbol.for("react.memo_cache_sentinel")) {
    t2 = <BuildersTableHeaderSkeleton />;
    t3 = <BuildersTableBodySkeleton />;
    $[2] = t2;
    $[3] = t3;
  } else {
    t2 = $[2];
    t3 = $[3];
  }
  let t4;
  if ($[4] !== t1) {
    t4 = <div className={t1}>{t2}{t3}</div>;
    $[4] = t1;
    $[5] = t4;
  } else {
    t4 = $[5];
  }
  return t4;
}
export { BuildersTableSkeleton };